export interface UserManagingCompanyAuthorities {
  userId?: number;
  managingCompanyId: number;
  authorities: ManagingCompanyAuthorityType[];
}

export enum ManagingCompanyAuthorityType {
  MANAGING_COMPANY_ADMIN = 'MANAGING_COMPANY_ADMIN',
  MANAGE_GLOBAL_AUTHORITY_REQUEST = 'MANAGE_GLOBAL_AUTHORITY_REQUEST'
}